<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">远程更新</span>
      </div>
      <div class="right">
        <Button type="primary" @click="editTask()">创建任务</Button>
      </div>
    </div>
    <div>
      <Table :columns="columns" :data="list">
        <template slot-scope="{ row }" slot="version">
          <span>{{ row.version + "." + row.plugin_version }}</span>
        </template>
        <template slot-scope="{ row }" slot="status">
          <span>{{ status[row.status].name }}</span>
        </template>
      </Table>
      <div class="t-right" style="margin-top: 20px">
        <Page @on-change="pageChange" @on-page-size-change="sizeChange" :current="page.p + 1" :total="total"
          :page-size="10" show-elevator show-sizer show-total />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      list: [],
      columns: [
        { title: "任务编号", key: "id", width: "100" },
        { title: "下发软件", key: "name" },
        { title: "下发版本", key: "version", slot: "version" },
        { title: "更新数量", key: "num" },
        { title: "下发状态", key: "status", slot: "status" },
        { title: "创建时间", key: "create_time" },
        { title: "备注", key: "note" },
        {
          title: "操作",
          key: "operate",
          width: "200",
          render: (h, data) => {
            let temp = [
              h(
                "Button",
                {
                  props: {
                    size: "small",
                    type: "warning",
                  },
                  style: { marginRight: "5px" },
                  on: {
                    click: () => {
                      this.editTask(data.row);
                    },
                  },
                },
                "编辑"
              ),
            ];
            if (data.row.status == 0) {
              temp.push(
                h(
                  "Button",
                  {
                    props: {
                      size: "small",
                      type: "success",
                    },
                    style: { marginRight: "5px" },
                    on: {
                      click: () => {
                        this.changeStatus(data.row.id, 1);
                      },
                    },
                  },
                  "下发"
                )
              );
            }
            if (data.row.status > 0) {
              temp.push(
                h(
                  "Button",
                  {
                    props: {
                      size: "small",
                      type: "success",
                    },
                    style: { marginRight: "5px" },
                    on: {
                      click: () => {
                        this.changeStatus(data.row.id, data.row.status == 2 ? 1 : 2);
                      },
                    },
                  },
                  data.row.status == 2 ? "开始" : "暂停"
                )
              );
            }
            temp.push(
              h(
                "Button",
                {
                  props: {
                    size: "small",
                    type: "error",
                  },
                  on: {
                    click: () => {
                      this.changeStatus(data.row.id, 3);
                    },
                  },
                },
                "删除"
              )
            );
            return temp;
          },
        },
      ],
      status: {
        0: { name: "待发布" },
        1: { name: "已发布" },
        2: { name: "暂停" },
        3: { name: "已删除" },
      },
      page: {
        p: 0,
        l: 10,
        sn: "",
        site_name: "",
        agent_id: 0,
        status: -1,
      },
      total: 0,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    ...mapActions([
      "GetVersionList",
      "SaveVersion",
    ]),
    getData() {
      console.log("参数", this.page);
      this.GetVersionList(this.page).then((res) => {
        this.total = res.total;
        this.list = res.data;
        this.list.map((item) => {
          item.create_time = item.create_time
            ? this.$moment(item.create_time, "YYYY-MM-DD HH:mm")
            : "";
        });
      });
    },
    editTask(item) {
      this.$router.push({
        name: "update-edit",
        params: { data: JSON.stringify(item) },
      });
    },
    submit() {
      let data = this.modal.data;
      if (!data.machine_id) {
        this.$Message.error("请选择设备!");
        return;
      }
      this.SaveMachineLog(data).then((res) => {
        this.modal.visible = false;
        this.$Message[res.status ? "success" : "error"](res.msg);
        if (res.status) {
          this.reset();
        }
      });
    },
    delete(row) {
      let data = {
        id: row.id,
        is_del: 1,
      };
      this.SaveMachineLog(data).then((res) => {
        this.$Message[res.status ? "success" : "error"](res.msg);
        if (res.status) {
          this.getData();
        }
      });
    },
    changeStatus(id, status) {
      let data = {
        id,
        status,
      };
      this.SaveVersion(data).then((res) => {
        this.$Message[res.status ? "success" : "error"](res.msg);
        if (res.status) {
          this.getData();
        }
      });
    },

    sizeChange(l) {
      this.page.l = l;
      this.getData();
    },
    pageChange(p) {
      this.page.p = p - 1;
      this.getData();
    },
    staffChange() {
      this.getData();
    },
    // 重置获取数据
    reset() {
      this.page = {
        p: 0,
        l: 10,
        sn: "",
        site_name: "",
        agent_id: 0,
        status: -1,
      };
      this.getData();
    },
  },
};
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
